import React, { Component } from 'react'
import { HexColorPicker, HexColorInput } from 'react-colorful'
import './styles/colorPicker.scss'

class ColorPicker extends Component {
    constructor(props) {
        super(props)
        this.state = {
            color: props.defaultValue || '#fffff',
            togglePicker: false,
        }
        this.wrapperRef = React.createRef()
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ showPicker: false })
        }
    }

    setColor = (color) => {
        const { name } = this.props
        const { onChange } = this.props
        this.setState({ color })
        if (onChange) onChange(color, name)
    }

    togglePicker = () => {
        this.setState((prevState) => ({
            ...prevState,
            showPicker: !prevState.showPicker,
        }))
    }

    render() {
        const { color, showPicker } = this.state
        const { label, position } = this.props
        return (
            <div className="uc-colorPicker">
                <div className={`pickerWrapper ${showPicker ? 'show' : 'hide'} ${position || 'top'}`} ref={this.wrapperRef}>
                    <HexColorPicker color={color} onChange={this.setColor} />
                </div>
                <div className="label">{label}</div>
                <div className="colorInput">
                    <HexColorInput prefixed className="colorPickerInput" color={color} onChange={this.setColor} />
                    <i className="fa-regular fa-eye-dropper dropper" onClick={this.togglePicker} />
                </div>
            </div>
        )
    }
}

export default ColorPicker
